(function( $ ) {
  'use strict';

  $(window).load(function() {
    const pageUrl = window.location.href;
    const regex = new RegExp("/page/*");

    const latestPostBlocks = $(".latest_news.with-pagination, .latest_custom_post_feed.with-pagination");

    if (regex.test(pageUrl) && latestPostBlocks.length > 0) {
      const offset = $(latestPostBlocks[0]).offset().top;
      $("html, body").animate({ scrollTop: offset }, 0);
    }
  })
})( jQuery );
